import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalEditFullyApprovedAlert() {
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "productApprovals.ApprovalEditFullyApprovedAlert.title"
    }),
    marginBlockEnd: "500",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "productApprovals.ApprovalEditFullyApprovedAlert.content"
    })
  });
}
export default ApprovalEditFullyApprovedAlert;